export const JWT_STORAGE_KEY = 'accessToken';
export const LOGGED_IN_AS_CLIENT_ADVISOR_ID = 'loggedInAsClientAdvisorId';
export const LOGGED_IN_AS_ADVISOR_ADMIN_ID = 'savvy-admin-logged-in-as-advisor-id';

export type StorageKey =
  | typeof JWT_STORAGE_KEY
  | typeof LOGGED_IN_AS_CLIENT_ADVISOR_ID
  | typeof LOGGED_IN_AS_ADVISOR_ADMIN_ID;
